export const getDiscountConfigByModule = (state) => (discountModule) =>
  state.discountConfig[discountModule];
